<template>
  <div class="blackout">
  <div class="popup profile-wrap " >
    <vue-headful :title="title" :description="title"/>
    <div class="title"> {{ title }}
      <div class="close"><a @click.prevent="s" href="#"> <img src="/img/profile/close-x.svg"/> </a></div>
    </div>
    <hr class="hr"/>
    <div class="popup-body">
      <div> Are you sure you want to remove facebook login method?</div>
      <div v-if="btn" @click="unlink" style="margin-top: 35px; margin-bottom: 30px;" class="btn btn-success">
        {{ btn }}
      </div>
      <div v-if="error" style="color: red; margin: 10px 0;">
        {{ error }}
      </div>
    </div>
    <hr class="hr"/>
    <div class="footer"><a @click.prevent="s" href="#">Cancel</a></div>
  </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  data: function () {
    return {
      delConf: "",
      title: "Unlink from Facebook",
      btn: "Unlink Facebook login",
      error: null
    };
  },
  methods: {
    ...mapActions('user', {
      unlinkFacebook: 'UNLINK_FACEBOOK'
    }),
    s() {
      console.log("Close", this.$store.state.status);
      this.$store.state.status = null;
    },
    unlink() {
      let th = this;

      this.unlinkFacebook().then(response => {
        if (response.data.success) {
          th.$store.state.status = null;
          this.$router.push({name: "Profile"});
        } else {
          this.error = response.data.message;
        }
      });

      /*FB.api("/me/permissions", "delete", function (r) {
        console.log("FB_DEL_PERMISSION", r);
        th.$http.post("/api/user/fb-unlink").then(response => {
          th.$store.state.status = null;
          console.log("fb-unlink", response);
          this.$router.push({name: "Profile"});
        });
      }); */
    }
  }
};
</script>
